module.exports = __webpack_public_path__ + "static/media/Adopter.3036bd1f.png";